<template>
  <Dialog v-model="visible" class="delete-dialog" :before-close="handleClose" :show-close="false">
    <template #header/>
    <icon-delete-circle class="icon-delete-circle"/>

    <h4 class="title">{{ $t('img.deleteTitle') }}</h4>

    <div class="dialog-footer">
      <el-button class="cancel-btn" @click="handleClose">{{ $t('img.cancel') }}</el-button>
      <el-button class="confirm-btn" @click="handlePicDelete">
        {{ $t('img.confirm') }}
      </el-button>
    </div>
  </Dialog>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  taskId: {  type: Number, default: 0 },
});

const visible = computed(() => props.visible);
const emit = defineEmits(['delete', 'update:visible']);

const handlePicDelete = async () => {
  try {
    const data = await useDeletePic({ taskId: props.taskId });
    if (data.code === 200) {
      emit('delete');
    }
  } catch (error) {
    console.log('DeletePic: ', error);
  } finally {
    handleClose();
  }
};

const handleClose = () => {
  emit('update:visible', false);
};


</script>
<style lang="scss">
.delete-dialog {

  border-radius: 20px;
  //width: 386x;
  width: calc(100% - 40px);
  max-width: 405px;
  box-sizing: border-box;
 
  @include responseTo("pc-767px") {
    padding: 50px 30px 30px !important;
  }
  @include responseTo("web-766px") {
    padding: 20px 20px 20px !important;
  }
  .icon-delete-circle {
    @include responseTo("pc-767px") {
      display: flex;
      margin: auto;
      margin-bottom: 25px;
      width: 100px;
      color: #1339F7;
    }
    @include responseTo("web-766px") {
      display: flex;
      margin: auto;
      margin-bottom: 20px;
      width: 80px;
      color: #1339F7;
    }
  }

  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // @include flexColumn(center);
    .title {
      margin-bottom: 30px;
      font-weight: bold;
      color: #000000;
      text-align: center;
      // padding: 0 30px;
      @include responseTo("pc-767px") {
        font-size: 20px;
        line-height: 28px;
      }
      @include responseTo("web-766px") {
        font-size: 18px;
        line-height: 23px;
      }
    }

    .dialog-footer {
      @include flex(center);
      width: 100%;
      gap: 12px;
      // padding: 0 30px;
    }

    .confirm-btn,
    .cancel-btn {
      flex: 1;
      height: 54px;
      border-radius: 10px;
      font-weight: 500;
      font-size: 16px;
      @include responseTo('pc-767px') {
        height: 54px;
      }

      @include responseTo('web-766px') {
        height: 44px;
      }
      &.cancel-btn {
        color: #1339F7;
        border-color: #1339F7;
        &:hover {
          background: transparent;
        }
      }
      &.confirm-btn {
        background: #1339F7;
        color: #fff;
        border: none;
      }
    }
  }
}
</style>
